import { render } from "./readOnly.vue?vue&type=template&id=55b3ef3d&scoped=true"
import script from "./readOnly.vue?vue&type=script&lang=js"
export * from "./readOnly.vue?vue&type=script&lang=js"

import "./readOnly.vue?vue&type=style&index=0&id=55b3ef3d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b3ef3d"]])

export default __exports__